module.exports = __webpack_public_path__ + "img/img_7.e782b71c.png";